  <div class="mx-auto" style="width: 250px;">
    <div class="loader"></div>
    <!--<img src="/assets/img/spinner.gif" style="margin-left:20px" />-->
    <h4 class="text-center">{{message}}</h4>
  </div>

